import Container from './MobileBatchActionWrapper.container';
import MobileBatchActionWrapper from './MobileBatchActionWrapper';

export default Container(MobileBatchActionWrapper);
